/// <amd-module name="Artifacts/Connect/components/ToolIcon" />
import { ITool } from "Artifacts/Connect/types";
import * as React from "react";
import { useComponentContext } from "VSS/Platform/Layout";
import { getAssetLocation } from "VSS/Platform/Location";
import { Image } from "VSSUI/Image";
import { css } from "VSSUI/Util";

export interface IToolIconProps {
  tool: ITool;
  className?: string;
}

const ToolIcon: React.FC<IToolIconProps> = ({ tool, className }) => {
  const context = useComponentContext();
  return (
    <Image
      src={getAssetLocation(context.pageContext, tool.imagePath)}
      className={css(className, tool.name)}
      alt={tool.name}
    />
  );
};

export { ToolIcon };
